import StateMasterService from "../../Services/StateMasterService";

export const LOADERTRUE = "LOADERTRUE";
export const LOADERFALSE = "LOADERFALSE";

export const FETCH_COUNTRY_REQUEST = "FETCH_COUNTRY_REQUEST";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILURE = "FETCH_COUNTRY_FAILURE";

export const FETCH_STATES_REQUEST = "FETCH_STATES_REQUEST";
export const FETCH_STATES_SUCCESS = "FETCH_STATES_SUCCESS";
export const FETCH_STATES_FAILURE = "FETCH_STATES_FAILURE";

export const SHOWALERTTRUE = "SHOWALERTTRUE";
export const SHOWALERTFALSE = "SHOWALERTFALSE";

export const SET_ROUTE = "SET_ROUTE";

export const handleAlert = (status, route, history) => (dispatch) => {
  if (status === "ok") {
    history.push(route);
    dispatch({ type: SHOWALERTFALSE });
  } else {
    dispatch({ type: SHOWALERTFALSE });
  }
};

export const getLoaderState = (status) => (dispatch) => {
  if (status) {
    dispatch({ type: LOADERTRUE });
  } else {
    dispatch({ type: LOADERFALSE });
  }
};

export const fetCountryList = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_COUNTRY_REQUEST });
  try {
    const response = await StateMasterService.CountryMaster(payload);
    dispatch({ type: FETCH_COUNTRY_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_COUNTRY_FAILURE, payload: error.message });
  }
};

export const fetchStateList = (payload) => async (dispatch) => {
  dispatch({ type: FETCH_STATES_REQUEST });
  try {
    const response = await StateMasterService.StateMaster(payload);
    dispatch({ type: FETCH_STATES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_STATES_FAILURE, payload: error.message });
  }
};
